import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DistributorsRoutingModule } from './distributors-routing.module';
import { DistributorsComponent } from './distributors.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import {AssignProductComponent} from './assignProduct/assign-product.component';
import {DistributorDetailComponent} from "./distributor-detail/distributor-detail.component";
import {UpdateTitleComponent} from "./update-title/update-title.component";
import {NgxBarcodeModule} from "ngx-barcode";

@NgModule({
  declarations: [
    DistributorsComponent,
    AssignProductComponent,
    DistributorDetailComponent,
    UpdateTitleComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DistributorsRoutingModule,
        NgZorroAntdModule,
        SharedModule,
        NgxBarcodeModule,
    ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class DistributorsModule { }
